module.exports = __webpack_public_path__ + "img/finitionInt.6552eb4f.jpg";